// extracted by mini-css-extract-plugin
export default {"about":"About_about__9QBNP","aboutBottom":"About_aboutBottom__SA2hZ"};